import { Pagination } from "@visiblethread/react-components";
import Ellipsis from "components/Ellipsis";
import ResizableContainer from "components/ResizableContainer";
import ContentInfo from "components/RowsAddedInfo";
import { paginationProps } from "constants/app";
import { elements } from "constants/types";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

const ContentHeader = ({
  documentId,
  docItemsLength,
  paginationConfig: { numberOfItems, itemsPerPage, initialPage, onPageChange },
  columnWidths,
  onResize,
  headerRef,
}) => {
  const configLoading = useSelector(
    (state) => state.dictionarySearch.config.loading
  );
  const data = useSelector((state) => state.dictionarySearch.content?.data);
  const previousLength = useSelector(
    (state) => state.dictionarySearch.content?.previousLength
  );
  const isLoading =
    configLoading?.find(
      (load) => load.element === elements.CONTENT && load.loading === true
    ) !== undefined;

  const getPagination = () => (
    <Pagination
      numberOfItems={numberOfItems}
      itemsPerPage={itemsPerPage}
      initialPage={initialPage}
      onPageChange={onPageChange}
      loadingConfig={{ loading: isLoading, message: "Calculating..." }}
    />
  );

  const getHeaderConfig = () => {
    let config = [];

    if (!documentId) {
      config.push({
        content: "Document",
        minWidth: 20,
      });
    }

    const rest = [
      {
        content: "Term(s)",
        minWidth: 20,
      },
      {
        content: "Location",
        minWidth: 20,
      },
      {
        content: "Ref",
        minWidth: 20,
      },
      {
        content: "Content",
        minWidth: 300,
      },
    ];

    config = config.concat(rest);

    return config;
  };

  const headerConfig = getHeaderConfig();

  return (
    <div className="content__header" data-testid="content-header">
      <span>Detail</span>
      <div className="content__header__info">
        {data.length > 0 && docItemsLength > 0 && (
          <ContentInfo
            count={data.length}
            previousLength={previousLength}
            isLoading={isLoading}
          />
        )}
        {data?.length && docItemsLength > 0 ? getPagination() : null}
      </div>
      <div ref={headerRef} className="content__header__row">
        {headerConfig.map(({ content, minWidth }, index) => (
          <ResizableContainer
            index={index}
            width={columnWidths[index]}
            minWidth={minWidth}
            disableResizing={index === headerConfig.length - 1}
            onResize={onResize}
          >
            <Ellipsis text={content} />
          </ResizableContainer>
        ))}
      </div>
    </div>
  );
};

export default ContentHeader;

ContentHeader.propTypes = {
  documentId: PropTypes.number,
  docItemsLength: PropTypes.number.isRequired,
  paginationConfig: paginationProps,
  columnWidths: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ).isRequired,
  onResize: PropTypes.func.isRequired,
  headerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};
